import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IAchivements } from 'app/shared/model/achivements.model';
import { getEntities as getAchivements } from 'app/entities/achivements/achivements.reducer';
import { IPoints } from 'app/shared/model/points.model';
import { getEntity, updateEntity, createEntity, reset } from './points.reducer';

export const PointsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const achivements = useAppSelector(state => state.achivements.entities);
  const pointsEntity = useAppSelector(state => state.points.entity);
  const loading = useAppSelector(state => state.points.loading);
  const updating = useAppSelector(state => state.points.updating);
  const updateSuccess = useAppSelector(state => state.points.updateSuccess);

  const handleClose = () => {
    navigate('/points' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAchivements({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...pointsEntity,
      ...values,
      achivements: achivements.find(it => it.id.toString() === values.achivements.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pointsEntity,
          achivements: pointsEntity?.achivements?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.points.home.createOrEditLabel" data-cy="PointsCreateUpdateHeading">
            <Translate contentKey="fivePlusApp.points.home.createOrEditLabel">Create or edit a Points</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="points-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fivePlusApp.points.referral')}
                id="points-referral"
                name="referral"
                data-cy="referral"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.points.collegeAdmission')}
                id="points-collegeAdmission"
                name="collegeAdmission"
                data-cy="collegeAdmission"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.points.graduation')}
                id="points-graduation"
                name="graduation"
                data-cy="graduation"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.points.master')}
                id="points-master"
                name="master"
                data-cy="master"
                type="text"
              />
              <ValidatedField label={translate('fivePlusApp.points.phd')} id="points-phd" name="phd" data-cy="phd" type="text" />
              <ValidatedField
                label={translate('fivePlusApp.points.communityService')}
                id="points-communityService"
                name="communityService"
                data-cy="communityService"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.points.crowedFunding')}
                id="points-crowedFunding"
                name="crowedFunding"
                data-cy="crowedFunding"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.points.startUp')}
                id="points-startUp"
                name="startUp"
                data-cy="startUp"
                type="text"
              />
              <ValidatedField
                label={translate('fivePlusApp.points.kindnessAct')}
                id="points-kindnessAct"
                name="kindnessAct"
                data-cy="kindnessAct"
                type="text"
              />
              <ValidatedField
                id="points-achivements"
                name="achivements"
                data-cy="achivements"
                label={translate('fivePlusApp.points.achivements')}
                type="select"
              >
                <option value="" key="0" />
                {achivements
                  ? achivements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/points" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PointsUpdate;
